import { Button, ErrorIcon, Flex, Typography } from '@iheartjane/reefer';
import type { PaddingProperties } from '@iheartjane/reefer';
import { useParams } from 'react-router';

type OptionalQueryParams = {
  brand_id: string;
  brand_name: string;
};
export interface UnavailableBrandSpecialProps extends PaddingProperties {
  backLink?: string;
  buttonLabel?: string;
  message: string;
  title?: string;
}
export const UnavailableBrandSpecial = ({
  backLink: link,
  buttonLabel: label,
  message,
  title = 'Jane Gold not available',
  ...props
}: UnavailableBrandSpecialProps) => {
  const { brand_name, brand_id } = useParams<OptionalQueryParams>();

  const formattedBrandName =
    brand_name &&
    brand_name
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  const brandNameForButton =
    formattedBrandName && formattedBrandName.length > 20
      ? 'Brand Page'
      : formattedBrandName;

  const backLink = link
    ? link
    : brand_id && brand_name
      ? `/brands/${brand_id}/${brand_name}`
      : '/brands';

  const buttonLabel = label
    ? label
    : brand_id && brand_name
      ? `Back to ${brandNameForButton}`
      : 'Back to Brands';

  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      maxWidth={420}
      mx="auto"
      {...props}
    >
      <ErrorIcon size="xxl" color="primary" />
      <Typography branded textAlign="center" variant="header-bold" mt={24}>
        {title}
      </Typography>
      <Typography color="grays-mid" textAlign="center" variant="body" mt={4}>
        {message}
      </Typography>
      <Button to={backLink} label={buttonLabel} mt={24} />
    </Flex>
  );
};
